import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  font-family: ",
        ";\n  color: ",
        ";\n  text-align: ",
        ";\n  text-decoration: ",
        ";\n  line-height: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled, { withTheme } from "styled-components";
var Text = styled.span.attrs(function(param) {
    var theme = param.theme, tag = param.tag, fontWeight = param.fontWeight, fontFamily = param.fontFamily, fontSize = param.fontSize, bold = param.bold, light = param.light, disabled = param.disabled, branded = param.branded;
    var pdFontWeight = theme.font.weight.default;
    if (light) {
        pdFontWeight = theme.font.weight.light;
    }
    if (bold) {
        pdFontWeight = theme.font.weight.bold;
    }
    if (fontWeight) {
        pdFontWeight = fontWeight;
    }
    var pdFontFamily = theme.font.family.primary;
    if (branded) {
        pdFontFamily = theme.font.family.branded;
    }
    if (fontFamily) {
        pdFontFamily = fontFamily;
    }
    var pdFontSize = theme.font.size.default;
    if (fontSize) {
        pdFontSize = fontSize;
    }
    var pdColor = theme.color.primary;
    if (disabled) {
        pdColor = theme.color.disabled;
    }
    return {
        as: tag,
        pdFontWeight: pdFontWeight,
        pdFontFamily: pdFontFamily,
        pdFontSize: pdFontSize,
        pdColor: pdColor
    };
})(_templateObject(), function(param) {
    var pdFontSize = param.pdFontSize;
    return pdFontSize;
}, function(param) {
    var pdFontWeight = param.pdFontWeight;
    return pdFontWeight;
}, function(param) {
    var pdFontFamily = param.pdFontFamily;
    return pdFontFamily;
}, function(param) {
    var pdColor = param.pdColor;
    return pdColor;
}, function(param) {
    var centered = param.centered;
    return centered ? "center" : "inherit";
}, function(param) {
    var underline = param.underline;
    return underline ? "underline" : "inherit";
}, function(param) {
    var tag = param.tag;
    return (tag === null || tag === void 0 ? void 0 : tag.match(/h[1-6]/)) ? "1.2em" : "1.5em";
});
export var Subtitle = withTheme(function(_param) /*#__PURE__*/ {
    var theme = _param.theme, props = _object_without_properties(_param, [
        "theme"
    ]);
    return _jsx(Text, _object_spread({
        tag: "h4",
        fontSize: theme.font.size.large,
        fontWeight: theme.font.weight.medium
    }, props));
});
export var Paragraph = function(props) {
    return /*#__PURE__*/ _jsx(Text, _object_spread({
        as: "p"
    }, props));
};
